module.exports = __webpack_public_path__ + "img/8.6f888d85.jpg";